import { Component, OnInit } from '@angular/core';
import { AppConfigService } from '../app-config.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(public appConfigService: AppConfigService) { }

  ngOnInit() {
  }


}
